//Creates new Spectrophotometer and assigns ID and type
export const createSpectrophotometer = (data) => {
  //data = {id, type}
  return { type: "CREATE_SPECTROPHOTOMETER", payload: data };
};

export const spectrophotometerToggleLid = (data) => {
  //data = {id, type}
  return { type: "SPECTROPHOTOMETER_TOGGLE_LID", payload: data };
};

export const spectrophotometerToggleSettingsModal = (data) => {
  //data = {id, type}
  return { type: "SPECTROPHOTOMETER_TOGGLE_SETTINGS_MODAL", payload: data };
};

//"spectrophotometer/id==1/conditions/wavelength=615"
export const spectrophotometerToggleInfoModal = (data) => {
  //data = {id, type}
  return { type: "SPECTROPHOTOMETER_TOGGLE_INFO_MODAL", payload: data };
};

export const spectrophotometerItemDrop = (data) => {
  return { type: "SPECTROPHOTOMETER_DROP_ITEM", payload: data };
};

export const spectrophotometerRemoveCuvette = (data) => {
  return { type: "SPECTROPHOTOMETER_REMOVE_CUVETTE", payload: data };
};

export const spectrophotometerOnClickPowerButton = (data) => {
  return { type: "SPECTROPHOTOMETER_CLICK_POWER_BUTTON", payload: data };
};

export const spectrophotometerOnClickZeroButton = (data) => {
  return { type: "SPECTROPHOTOMETER_CLICK_ZERO_BUTTON", payload: data };
};

export const spectrophotometerSetWavelength = (data) => {
  return { type: "SPECTROPHOTOMETER_SET_WAVELENGTH", payload: data };
};
